import type { AccountNumber } from '../../../generated-types';
import { SetAccount } from '../Transfer/form/actions';
import { CommonTransferState } from './CommonTransferState';

export const either = (payloadAccount: AccountNumber, stateAccount?: AccountNumber): AccountNumber | undefined => {
    return stateAccount && stateAccount?.value === payloadAccount?.value ? undefined : stateAccount;
};

const selectTransferAccounts = <TState extends CommonTransferState>(state: TState, payload: SetAccount): TState => {
    const { accountNumber, setAccountType } = payload;
    let { fromAccount, toAccount } = state;

    if (setAccountType === 'SET_FROM_ACCOUNT') {
        fromAccount = accountNumber;
        toAccount = either(accountNumber, toAccount);
    } else if (setAccountType === 'SET_TO_ACCOUNT') {
        toAccount = accountNumber;
        fromAccount = either(accountNumber, state.fromAccount);
    }

    return {
        ...state,
        fromAccount,
        toAccount,
        showFromAccounts: false,
        showToAccounts: false,
    };
};

export default selectTransferAccounts;
